import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Outlet } from 'react-router-dom';
import SentryPWAHeader from '../components/sentry-pwa/SentryPWAHeader';
import SentryAgentBottomNav from '../components/sentry-pwa/SentryAgentBottomNav';

const PWAContainer = styled.div`
  min-height: 100vh;
  background: #000000;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  position: relative;
  padding-bottom: 40px;
  width: 100%;
  max-width: 100%;
  
  @media (min-width: 768px) {
    max-width: 414px !important;
    width: 414px !important;
    margin: 0 auto;
    box-shadow: 0 0 40px rgba(0, 0, 0, 0.8),
                0 0 0 12px rgba(0, 0, 0, 0.5),
                0 0 0 16px rgba(168, 85, 247, 0.15);
    min-height: 100vh;
    max-height: 100vh;
    overflow: hidden;
    border-radius: 24px;
    position: relative;
    z-index: 1;
    left: 50%;
    transform: translateX(-50%);
  }
`;

const ContentWrapper = styled.div`
  flex: 1;
  width: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
`;

const SentryAgentLayout: React.FC = () => {
  useEffect(() => {
    if (window.innerWidth >= 768) {
      document.body.classList.add('sentry-pwa-desktop-mode');
      document.documentElement.classList.add('sentry-pwa-desktop-mode');
    }

    const handleResize = () => {
      if (window.innerWidth >= 768 && window.location.pathname.startsWith('/sentry-agent')) {
        document.body.classList.add('sentry-pwa-desktop-mode');
        document.documentElement.classList.add('sentry-pwa-desktop-mode');
      } else {
        document.body.classList.remove('sentry-pwa-desktop-mode');
        document.documentElement.classList.remove('sentry-pwa-desktop-mode');
      }
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      document.body.classList.remove('sentry-pwa-desktop-mode');
      document.documentElement.classList.remove('sentry-pwa-desktop-mode');
    };
  }, []);

  return (
    <PWAContainer>
      <SentryPWAHeader mode="agent" />
      <ContentWrapper>
        <Outlet />
      </ContentWrapper>
      <SentryAgentBottomNav />
    </PWAContainer>
  );
};

export default SentryAgentLayout;
